import {
  FormControl,
  FormLabel,
  OutlinedTextFieldProps,
  styled,
  TextField as MuiTextField,
} from "@mui/material";

interface Props extends OutlinedTextFieldProps {}

export function TextField(props: Props) {
  const { label, fullWidth, className, ...formProps } = props;
  return (
    <StyledFormControl fullWidth={fullWidth} className={className}>
      {label && <FormLabel>{label}</FormLabel>}
      <MuiTextField fullWidth={fullWidth} {...formProps} />
    </StyledFormControl>
  );
}
const StyledFormControl = styled(FormControl)`
  .MuiFormLabel-root {
    margin-bottom: ${({ theme }) => theme.spacing(0.5)};
  }
  .MuiFormHelperText-root {
    margin-left: 0;
  }
`;
